import IInlineVideo from '@models/IInlineVideo';
import InViewVideo from '@molecules/InViewVideo/InViewVideo';
import SoftLoadWrapper from '@molecules/SoftLoadWrapper/SoftLoadWrapper';

const InlineVideo = ({
  title,
  text,
  video,
  autoPlay,
  coverImage,
  meta,
  subtitles,
  anchorId = '',
}: IInlineVideo) => (
  <section
    className="component-padding bg-white dark:bg-black-100"
    id={`a-${anchorId}`}
    data-testid="CT-10-C-Inline-Video"
  >
    <SoftLoadWrapper>
      <div className="inner two-col-spacing container relative flex flex-col">
        {(title || text) && (
          <div className="max-lg:order-last max-lg:mt-7.5 lg:mb-[70px] lg:grid lg:grid-cols-12">
            <div className="flex flex-col gap-y-5 lg:col-span-6 lg:col-start-2 lg:gap-y-7.5">
              {title && (
                <p
                  className="h3 text-black-100 dark:text-white"
                  data-testid="CT-10-C-Inline-Video-Title"
                >
                  {title}
                </p>
              )}

              {text && (
                <div
                  className="body-two text-grey-450 dark:text-grey-500"
                  dangerouslySetInnerHTML={{
                    __html: text,
                  }}
                  data-testid="CT-10-C-Inline-Video-Text"
                />
              )}
            </div>
          </div>
        )}

        <div className="relative col-span-12 w-full xl:col-span-10 xl:col-start-2 xl:col-end-12">
          {video?.url && (
            <InViewVideo
              autoPlay={autoPlay}
              coverImage={coverImage}
              meta={meta}
              subtitles={subtitles}
              video={video}
              dataTestId="CT-10-C-Inline-Video-In-View-Video"
            />
          )}

          {!!meta?.editHints?.coverImage && (
            // EPISERVER EDIT *BUTTON*
            <span
              className="-right-100 absolute top-0 right-0 text-white"
              data-epi-property-name={meta.editHints.coverImage}
            >
              Edit Cover Image
            </span>
          )}
        </div>
      </div>
    </SoftLoadWrapper>
  </section>
);

export default InlineVideo;
